import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

import {
  FUND_LITERATURE,
  FUND_PERFORMANCE,
  LITERATURE_FUND,
  PERFORMANCE_VALUE,
  RETURN_TYPE_MONTH_END,
} from '../../constants/constant.content'
import { NUMBER_ONE, NUMBER_ZERO } from '../../constants/constant.numbers'
import { TABLE_COLUMN_MAPPINGS } from '../../constants/table-column-mapping'
import { ObservableService } from '../services/observable-service/observable.service'
import { AssetClassModel } from './asset-class-model'
import { ProductTypeModel } from './product-type-model'

@Injectable({
  providedIn: 'root',
})
export class FilterModel {
  telecastFilterBy: Observable<AssetClassModel>
  filterByData: BehaviorSubject<AssetClassModel>
  telecastProductType: Observable<ProductTypeModel>
  productTypeData: BehaviorSubject<ProductTypeModel>
  subAssetSelectedCount = NUMBER_ZERO

  constructor(
    private productTypeModel: ProductTypeModel,
    private assetClassModel: AssetClassModel,
    private observableService: ObservableService,
  ) {
    this.productTypeData = new BehaviorSubject(this.productTypeModel)
    this.telecastProductType = this.productTypeData.asObservable()

    this.filterByData = new BehaviorSubject(this.assetClassModel)
    this.telecastFilterBy = this.filterByData.asObservable()
  }
  editDataFilterBy(data: any) {
    this.filterByData.next(data)
  }
  editDataProductType(data: any) {
    this.productTypeData.next(data)
  }
  isTrue(filterByLevel1Array: any) {
    for (const key in filterByLevel1Array) {
      if (filterByLevel1Array[key]) {
        return true
      }
    }
    return false
  }
  clearAllFilter() {
    this.subAssetSelectedCount = NUMBER_ZERO
    const productType = new ProductTypeModel()
    const defaultAssetClass = new AssetClassModel()
    productType.isProductTypeClicked = true
    this.observableService.viewFilterByClick('')
    this.observableService.filterBySelectedItem({
      inputId: '',
      isSelected: false,
    })
    this.editDataProductType(productType)
    this.editDataFilterBy(defaultAssetClass)
    this.observableService.viewProductClick(productType.assetCaas.allFunds)
  }
  checkCollectiveTrustWithCashEquivalentScenario(
    selectedProductType: string,
    filter: AssetClassModel,
  ): AssetClassModel {
    if (
      selectedProductType === filter.assetCaas.trusts &&
      filter.filterByLevel1.cashEquivalent.value
    ) {
      filter.filterByLevel1.cashEquivalent.level2.forEach((subAsset, index) => {
        if (subAsset.text === filter.assetCaas.stableValue) {
          filter.filterByLevel1.cashEquivalent.level2[index].value = true
        }
      })
    }
    return filter
  }
  getSortColumnValue(columnName: string): string {
    return TABLE_COLUMN_MAPPINGS.get(columnName.trim()) || ''
  }

  setSubAssetSelectedCount(count: number) {
    this.subAssetSelectedCount = count
  }

  getSubAssetSelectedCount(): number {
    return this.subAssetSelectedCount
  }

  isMultipleSubAssetSelected(): boolean {
    return this.subAssetSelectedCount > NUMBER_ONE
  }
  setFilter(displayTypeName: string) {
    const filters = {
      monthEndReturnNAV: {
        selectedTab: PERFORMANCE_VALUE,
        toggleOn: false,
        returnType: RETURN_TYPE_MONTH_END,
        selectedName: FUND_PERFORMANCE,
      },
      literature: {
        selectedTab: FUND_LITERATURE,
        toggleOn: false,
        returnType: '',
        selectedName: LITERATURE_FUND,
      },
      monthEndReturnsMarketETF: {
        selectedTab: PERFORMANCE_VALUE,
        toggleOn: true,
        returnType: RETURN_TYPE_MONTH_END,
        selectedName: FUND_PERFORMANCE,
      },
    }
    return filters[displayTypeName]
  }
}
